import { Pipe, PipeTransform } from '@angular/core';
import { IconName, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { RouterDirection } from '@ionic/core';

export class StackedListField {
  property?: string | Function;
  pipe?: 'currency' | 'number' | 'date';
  icon?: IconName;
  color?: string | Function;
}

export class StackedListItem {
  fields: StackedListField[];
  image?: string;
  routerUrl?: string | Function;
  routerDirection?: RouterDirection;
  endIcons?: (IconName | Function)[];
  disabled?: boolean | Function;
  icons?: StackedListItemEndIcon[];
  avatar?: string | Function;
  /** Optioneel: kleurwaarde per rij (bijv. voor linkerkant streep); wordt gezet als data-mark-color op ion-item. */
  rowMarkColor?: (item: any) => string | null;
}

export class StackedListItemEndIcon {
  icon: IconName | Function;
  color?: string | Function;
  size?: SizeProp;
}

@Pipe({
  name: 'displayProp',
  pure: true
})
export class DisplayPropPipe implements PipeTransform {
  transform(item: any, field: StackedListField) {
    if (typeof field.property === 'string') {
      return item[field?.property];
    } else {
      return field.property(item);
    }
  }
}

@Pipe({
  name: 'displayAvatar',
  pure: true
})
export class DisplayAvatarPipe implements PipeTransform {
  transform(item: any, listItem: StackedListItem) {
    if (typeof listItem.avatar === 'string') {
      return listItem.avatar;
    } else {
      return listItem.avatar(item);
    }
  }
}

@Pipe({
  name: 'displayListIcon',
  pure: true
})
export class DisplayListIconPipe implements PipeTransform {
  transform(item: any, icon: string | Function) {
    if (!icon) {
      return null;
    }

    if (typeof icon === 'string') {
      return icon;
    } else {
      return icon(item);
    }
  }
}

@Pipe({
  name: 'displayColor',
  pure: true
})
export class DisplayColorPipe implements PipeTransform {
  transform(item: any, color: string | Function) {
    if (typeof color === 'string') {
      return color;
    } else {
      return color(item);
    }
  }
}

